import { Card, Checkbox, List, Space } from 'antd'
import uniq from 'lodash/uniq'
import { Dispatch, FC, SetStateAction, useCallback } from 'react'

import { DrilldownTableColumnListEditor } from './DrilldownTableColumnListEditor'
import { useDrilldownTableConfig } from './DrilldownTableConfigContext'
import { SchemaTypeSelect } from './SchemaTypeSelect'

export const DrilldownTableConfigPanel: FC = () => {
  const {
    groupByType,
    setGroupByType,
    enabledExtraColumnIds,
    setEnabledExtraColumnIds,
    extraColumns,
    showFocusColumn,
    setShowFocusColumn,
  } = useDrilldownTableConfig()

  const extraColumnEnabledSetter = useCallback<
    (id: string) => Dispatch<SetStateAction<boolean>>
  >(
    (id) => (enabled: SetStateAction<boolean>) =>
      setEnabledExtraColumnIds?.((prevEnabledIds) => {
        const prevEnabled = prevEnabledIds.includes(id)
        const newEnabled =
          typeof enabled === 'function' ? enabled(prevEnabled) : enabled
        if (newEnabled === prevEnabled) {
          return prevEnabledIds
        }
        return newEnabled
          ? uniq([...prevEnabledIds, id])
          : prevEnabledIds.filter((prevId) => prevId !== id)
      }),
    [setEnabledExtraColumnIds]
  )

  return (
    <Space orientation='vertical' size='middle' style={{ width: '100%' }}>
      <Card title='Options'>
        <Space orientation='vertical' style={{ width: '100%' }}>
          <SchemaTypeSelect
            label='Group By'
            selectedType={groupByType}
            setSelectedType={setGroupByType}
          />
          <Checkbox
            checked={showFocusColumn}
            disabled={!setShowFocusColumn}
            onChange={({ target: { checked } }) =>
              setShowFocusColumn?.(checked)
            }>
            Show focus column
          </Checkbox>
        </Space>
      </Card>

      <Card title='Columns'>
        <DrilldownTableColumnListEditor />
      </Card>

      {setEnabledExtraColumnIds && !!extraColumns.length && (
        <Card title='Special Columns'>
          <List
            bordered
            dataSource={[...extraColumns]}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <Checkbox
                    key={'checkboxEnabled'}
                    checked={enabledExtraColumnIds.includes(item.id)}
                    onChange={({ target: { checked } }) =>
                      extraColumnEnabledSetter(item.id)(checked)
                    }
                  />,
                ]}>
                {item.name}
              </List.Item>
            )}
          />
        </Card>
      )}
    </Space>
  )
}
